import { MANAGER_SCOPES, USER_TYPES } from "./constants";

export const initDataTableHeaders = (headers = []) => {
    return headers.map((item, index, array) => ({
        ...item,

        formatter: initFormatter(item),

        align: item.align ?? "start",
        divider: item.divider ?? index != array.length - 1,

        class: (item.class || "") + " white-space-pre-line",
        cellClass: (item.cellClass || "") + " caption line-height-1-5 white-space-pre-line",
    }));
};

function initFormatter(header = {}) {
    if (header.formatter) return header.formatter;
    switch (header.formatterType) {
        case "date": {
            return (value) => value?.toDate?.() || value || "-";
        }
        case "datetime": {
            return (value) => value?.toDateTime?.() || value || "-";
        }
        case "number": {
            return (value) => ((value?.format?.() || value) + (header.suffix || "")).trim();
        }

        default: {
            return (value) => value ?? "-";
        }
    }
}

export const initUser = (user = {}) => ({
    ...user,

    _terms: user?._terms || [],

    username: user?.username || null,
    password: user?.password || null,

    name: user?.name || null,
    email: user?.email || null,
    phone: user?.phone || null,
    promoterCode: user?.promoterCode || null,
});

export const initManager = (form = {}) => ({
    ...(form || {}),

    username: form?.username ?? null,
    password: form?.password ?? null,
    subPassword: form?.subPassword ?? null,
    type: USER_TYPES.MANAGER.value,

    scope: [...(form?.scope ?? [MANAGER_SCOPES.manager.value])],
});

export const initBank = () => ({
    code: null,
    accountNumber: null,
    accountHolder: null,
});

export const initPromoterApprovalInquiry = () => ({
    _terms: [],
    ci: null,
    phone: null,
    bank: initBank(),
    residentRegistrationNumber: null,
});

export const initOrderReceiver = ({ receiver: { name = null, phone = null, email = null, postcode = null, address1 = null, address2 = null } = {} } = {}) => ({
    name,
    phone,
    email,
    postcode,
    address1,
    address2,
});

export const initOrder = (order = {}) => ({
    ...order,
    receiver: initOrderReceiver(order),
    requestMessage: order?.requestMessage || null,
});

export const initPurchase = (purchase = {}) => ({
    ...purchase,
    claimStatus: purchase?.claimStatus || null,
    claimReason: purchase?.claimReason || null,
    claimReasonDetails: purchase?.claimReasonDetails || null,
});

export const initApplication = (application = {}) => ({
    ...application,
    _terms: application?._terms || [],
    name: application?.name || null,
    phone: application?.phone || null,
    birth: application?.birth || null,
    round: application?.round || null,

    email: application?.email || null,
    qualification_type: application?.qualification_type || null,
    spouse: initSpouse(application?.spouse),
    supply_type: application?.supply_type || null,
    supply_category: application?.supply_category || null,
    earning_rank: application?.earning_rank || null,
    region_rank: application?.region_rank || null,
    isHomeless: application?.isHomeless != null ? application.isHomeless : null,
    isAsset: application?.isAsset != null ? application.isAsset : null,
    isCar: application?.isCar != null ? application.isCar : null,
    files: application?.files || {},
});

export const initSpouse = (spouse = {}) => ({
    name: spouse?.name || null,
    phone: spouse?.phone || null,
    birth: spouse?.birth || null,
});
